<template>
  <b-modal
    ref="modalProjects"
    :hide-footer="true"
    size="xl"
  >
    <div class="d-flex align-items-center">
      <h4>
        {{ $t('projects.modal-title') }}
      </h4>
      <b-button-group class="ml-auto">
        <b-button
          id="btn-clean"
          variant="outline-primary"
          class="btn-icon"
          @click="clearFilters()"
        >
          <feather-icon icon="Trash2Icon" />
          <b-tooltip
            triggers="hover"
            target="btn-clean"
            :title=" $t('common.clean-filter')"
            :delay="{ show: 100, hide: 50 }"
          />
        </b-button>
        <b-button
          id="btn-refresh"
          variant="outline-primary"
          class="btn-icon"
          @click="refresh()"
        >
          <feather-icon icon="RefreshCcwIcon" />
          <b-tooltip
            triggers="hover"
            target="btn-refresh"
            :title=" $t('common.refresh')"
            :delay="{ show: 100, hide: 50 }"
          />
        </b-button>
      </b-button-group>
    </div>
    <projects-list-table
      ref="projectsListTable"
      :modal="true"
      :callback="callback"
    />
  </b-modal>
</template>

<script>
import {
  BButton, BButtonGroup, BTooltip,
} from 'bootstrap-vue'
import ProjectsListTable from '@/views/projects/ProjectsListTable.vue'

export default {
  components: {
    BButton,
    BButtonGroup,
    BTooltip,
    ProjectsListTable,
  },
  data() {
    return {
      callback: null,
    }
  },
  methods: {
    cancel() {
      this.$refs.modalProjects.hide()
    },
    show(callback) {
      this.callback = callback
      this.$refs.modalProjects.show()
    },
    refresh() {
      this.$refs.projectsListTable.refresh()
    },
    clearFilters() {
      this.$refs.projectsListTable.clearFilters()
    },
  },
}
</script>

<style >
.modal-backdrop {
    opacity: 0.9;
}
</style>
